import { Box, IconButton } from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"
import type { ReactElement, ReactNode } from "react"
import { Header4 } from "../../atoms"

import "./dialog-window-header.styles.scss"

export interface IDialogWindowHeaderProps {
  title: string
  icon?: ReactNode
  onClose: () => void
}

export function DialogWindowHeader(props: IDialogWindowHeaderProps): ReactElement {
  const { title, icon, onClose } = props

  return (
    <Box className="dialog-window-header">
      <Box className="dialog-window-header-title">
        <Header4>{title}</Header4>
        {icon}
      </Box>
      <IconButton className="dialog-window-header-iconbutton" onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </Box>
  )
}
